/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    selectedFilterOrg:{
        data:[],
        selectedArr:[], 
        unselectedArr:[],
        isCheckedUsersAll:true,
        searchVal:'',
        totalUsers:0
        
    }
    
}
const wellnessOrganizationSlice = createSlice({
    name: 'selectedFilterOrg',
    initialState: initialState,
    reducers: {
     
        toggleRowSelection: (state, action) => {
            let column=action.payload[0]
            const dataItems=action?.payload[1]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            const isChecked = action?.payload[4]
            if(isChecked){
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedFilterOrg.unselectedArr.includes(column)?state.selectedFilterOrg.unselectedArr=state.selectedFilterOrg?.unselectedArr?.filter(item=>item!==column):''
                    state.selectedFilterOrg.selectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedFilterOrg.unselectedArr.includes(column)?state.selectedFilterOrg.unselectedArr=state.selectedFilterOrg.unselectedArr.filter(item=>item!==column):''
                    state.selectedFilterOrg.selectedArr.push(column)
                }
            }
            
            else{
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedFilterOrg.selectedArr.includes(column)?state.selectedFilterOrg.selectedArr=state.selectedFilterOrg?.selectedArr?.filter(item=>item!==column):''
                    state.selectedFilterOrg.unselectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedFilterOrg.selectedArr.includes(column)?state.selectedFilterOrg.selectedArr=state.selectedFilterOrg.selectedArr.filter(item=>item!==column):''
                    state.selectedFilterOrg.unselectedArr.push(column)
                }
                
            }
            if(complete_list_or_searched_list==='complete_list'){
                if(state.selectedFilterOrg.selectedArr.length===0&&state.selectedFilterOrg.unselectedArr.length===0||(state.selectedFilterOrg.selectedArr.length===state.selectedFilterOrg.totalUsers)){
                    state.selectedFilterOrg.isCheckedUsersAll=true
                }else{
                    state.selectedFilterOrg.isCheckedUsersAll=false
                }
            }else if(complete_list_or_searched_list==='searched_list'){
                if((dataItems?.every(item=>state.selectedFilterOrg.selectedArr.includes(item)))&&(!dataItems.some(item=>state.selectedFilterOrg.unselectedArr.includes(item)))||(action.payload[5]===true&&(!dataItems.some(item=>state.selectedFilterOrg.unselectedArr.includes(item))))){
                    state.selectedFilterOrg.isCheckedUsersAll=true
                } else{
                    state.selectedFilterOrg.isCheckedUsersAll=false
                }
            }
            

        },
        selectAllOrgRows:(state,action)=>{
            // if(action.payload[0]===false){
            //     state.selectedFilterOrg.selectedArr=state.selectedFilterOrg.selectedArr.filter(
            //         (element) => !action.payload[1]?.map((item)=>item?._id).includes(element)
            //     );
            //     state.selectedFilterOrg.isCheckedUsersAll=false
            // }
            // else{
            //     const newData = action.payload[1]?.map((item) => item?._id);

            //     // Filter out elements that already exist in state.selectedFilterOrg.selectedArr[index]
            //     const uniqueData = newData.filter((item) => !state.selectedFilterOrg.selectedArr.includes(item));
            //     // state.selectedFilterOrg.selectedArr[index].push(action.payload[1]?.data?.map((item)=>item?.user_id))
            //     state.selectedFilterOrg.selectedArr.push(...uniqueData)
            //     state.selectedFilterOrg.isCheckedUsersAll=true
            // }
            state.selectedFilterOrg.isCheckedUsersAll=action.payload[0]
            const dataItems= action.payload[1]?.map(item=>item._id)
            const searchedItem = action.payload[2]
            if(searchedItem?.trim()===''){
                state.selectedFilterOrg.selectedArr=[]
                state.selectedFilterOrg.unselectedArr=[]
            }else{
                if(action.payload[0]===false){
                    state.selectedFilterOrg.selectedArr?.length>0? state.selectedFilterOrg.selectedArr = state.selectedFilterOrg.selectedArr.filter(item=> !dataItems.includes(item)):''
                    let newArr= new Set([...state.selectedFilterOrg.unselectedArr, ...dataItems])
                    state.selectedFilterOrg.unselectedArr = [...newArr]
                }else if (action.payload[0]===true){
                    let newArr = new Set([...state.selectedFilterOrg.selectedArr, ...dataItems]);
                    state.selectedFilterOrg.selectedArr = [...newArr]
                    state.selectedFilterOrg.unselectedArr?.length>0? state.selectedFilterOrg.unselectedArr = state.selectedFilterOrg.unselectedArr.filter(item=> !dataItems.includes(item)):''
                }
                
            }
           
 
        },
     
        
        searchReducerr:(state,action)=>{
            // const allExistMethod1 = action?.payload[0]?.every((item2) =>
            //     state.selectedFilterOrg.selectedArr?.some((item1) => item1 === item2._id)
            // )
            // if(allExistMethod1){
            //     state.selectedFilterOrg.isCheckedUsersAll=true
            // }
            // else{
            //     state.selectedFilterOrg.isCheckedUsersAll=false
            // }
            const dataItems=action?.payload[0]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[1]
            const selectAllofSearch= action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            if(complete_list_or_searched_list==='complete_list'){
                if((selectAllofSearchOrCompleteList&&state.selectedFilterOrg.unselectedArr.length===0&&action.payload[4]!=='empty')||(state.selectedFilterOrg.selectedArr.length===state.selectedFilterOrg.totalUsers&&action.payload[4]!=='empty')){
                    state.selectedFilterOrg.isCheckedUsersAll=true
                }else{
                    state.selectedFilterOrg.isCheckedUsersAll=false
                }
            }else{
                if((dataItems.every(item => state.selectedFilterOrg.selectedArr.includes(item))||(selectAllofSearchOrCompleteList&&!(dataItems.some(item=>state.selectedFilterOrg.unselectedArr.includes(item)))))){
                    state.selectedFilterOrg.isCheckedUsersAll=true
    
                }else{
                    state.selectedFilterOrg.isCheckedUsersAll=false
                }
            }
           

            
        },
        handleTotalUsers:(state,action) => {
            state.selectedFilterOrg.totalUsers = action.payload[0]
        },
       
        resetOrgList:(state)=>{
            state.selectedFilterOrg.selectedArr=[], 
            state.selectedFilterOrg.isCheckedUsersAll=true,
            state.selectedFilterOrg.data=[],
            state.selectedFilterOrg.unselectedArr=[],
            state.selectedFilterOrg.searchVal='',
            state.selectedFilterOrg.totalUsers=0
   

        },
        handleFillFromSearchParamsOrg:(state,action) => {
            state.selectedFilterOrg.selectedArr= action.payload[0]
            state.selectedFilterOrg.unselectedArr=action.payload[1]
        },
        resetTempFilterOrgOpen:(state)=>{
            state.selectedFilterOrg.selectedArr=[], 
            state.selectedFilterOrg.isCheckedUsersAll=true,
            state.selectedFilterOrg.unselectedArr=[]
        },
        handleEmptyOrgDropdown:(state)=>{
            state.selectedFilterOrg.isCheckedUsersAll=false,
            state.selectedFilterOrg.selectedArr=[],
            state.selectedFilterOrg.unselectedArr=[]
        }
       

    }
});

export const { handleFillFromSearchParamsOrg,resetTempFilterOrgOpen,resetOrgList,searchReducerr,toggleRowSelection,selectAllOrgRows,handleTotalUsers,handleEmptyOrgDropdown} = wellnessOrganizationSlice.actions;
export default wellnessOrganizationSlice.reducer;
